import Cable from 'actioncable';
import dataModel from '../../models/DataModel';
import _ from 'lodash';

let startTimer = null;
export default class ActionCableConnector {
  constructor() {
    this.cable = null;
    this.cable = null;
    this.token = null;
    this.company_id = null;
    this.totalConnected = 0;
    this.setupListener = this.setupListener.bind(this);
    this.notificationConnected = this.notificationConnected.bind(this);
    this.subscriptionDisconnected = this.subscriptionDisconnected.bind(this);
    this.notificationRejected = this.notificationRejected.bind(this);
    this.notificationReceived = this.notificationReceived.bind(this);
    this.dataUpdateConnected = this.dataUpdateConnected.bind(this);
    this.dataUpdateConnectedAdmin = this.dataUpdateConnectedAdmin.bind(this);
    this.dataUpdateRejected = this.dataUpdateRejected.bind(this);
    this.dataUpdateReceived = this.dataUpdateReceived.bind(this);
    this.dataUpdateRejectedAdmin = this.dataUpdateRejectedAdmin.bind(this);
    this.dataUpdateReceivedAdmin = this.dataUpdateReceivedAdmin.bind(this);
    this.internalUpdate = this.internalUpdate.bind(this);
    
    this.subscribeToNotifications = this.subscribeToNotifications.bind(this);
    this.subscribeToDataUpdates = this.subscribeToDataUpdates.bind(this);
    this.subscribeToDataUpdatesAdmin = this.subscribeToDataUpdatesAdmin.bind(this);
    this.startCable = this.startCable.bind(this);

    this.notificationSubscription = null;
    this.dataUpdateSubscriptions = null;

    this.doUpdateReceived = this.doUpdateReceived.bind(this);
    this.register = this.register.bind(this);
    this.unregister = this.unregister.bind(this);
    this.registerCallback = this.registerCallback.bind(this);
    this.unregisterCallback = this.unregisterCallback.bind(this);
    this.registeredCallbacks = {};

    // TODO: additional mechanism for registering by ID

    /**
     * _new_registeredCallbacks = {
     *    type1 (e.g. updateProject): {
     *      generic: [handler1, handler2, handler3]
     *      1: [handler4, handler5],
     *      23: [handler6, handler7]
     *    }
     * }
     */
    this._new_registeredCallbacks = {};
  }

  subscriptionDisconnected() {
    if (this.cable && this.hasBeenConnected) {
      this.hasBeenConnected = false;
      this.stopCable();
      this.startCable(true);
    }
  }

  notificationRejected() {
    dataModel.displayInfoErrorMessage('Action Cable connection rejected for User Notifications!', 15, 2);
  }

  dataUpdateRejected() {
    dataModel.displayInfoErrorMessage('Action Cable connection rejected for Data Updates!', 15, 2);
  }
  
  dataUpdateRejectedAdmin() {
    dataModel.displayInfoErrorMessage('Action Cable connection rejected for Admin Data Updates!', 15, 2);
  }
  
  notificationConnected() {
    this.hasBeenConnected = true;
    this.totalConnected++;
  }

  dataUpdateConnected() {
    this.hasBeenConnected = true;
    this.totalConnected++;
  }

  dataUpdateConnectedAdmin() {
    this.hasBeenConnected = true;
    this.totalConnected++;
  }

  subscribeToNotifications() {
    if (this.cable) {
      this.notificationSubscription = this.cable.subscriptions.create(
        {
          channel: 'NotificationsChannel',
          token: localStorage.token,
          current_company: localStorage.current_company_id,
        },
        {
          connected: this.notificationConnected,
          disconnected: this.subscriptionDisconnected,
          received: this.notificationReceived,
          rejected: this.notificationRejected,
        });
    }
  }

  subscribeToDataUpdates() {
    if (this.cable) {
      this.dataUpdateSubscriptions = this.cable.subscriptions.create(
        {
          channel: 'DataUpdateChannel',
          token: localStorage.token,
          current_company: localStorage.current_company_id,
        },
        {
          connected: this.dataUpdateConnected,
          disconnected: this.subscriptionDisconnected,
          received: this.dataUpdateReceived,
          rejected: this.dataUpdateRejected,
        });
    }
  }
  
  subscribeToDataUpdatesAdmin() {

    const currentUser = dataModel.stateTree.new_users.currentUser;
    if (currentUser && currentUser.super_admin) {
      this.dataUpdateSubscriptionsAdmin = this.cable.subscriptions.create(
        {
          channel: 'AdminDataUpdateChannel',
          token: localStorage.token,
        },
        {
          connected: this.dataUpdateConnectedAdmin,
          disconnected: this.subscriptionDisconnected,
          received: this.dataUpdateReceivedAdmin,
          rejected: this.dataUpdateRejectedAdmin,
        });
    }
  }
  
  setupListener() {
    // set up the action cable listener
    let url = process.env.REACT_APP_API.replace('http', 'ws');
    if (url.lastIndexOf('/') == url.length - 1) {
      url = url.substr(0, url.length - 1);
    }
    url += '/cable?token=' + localStorage.token + '&current_company=' + localStorage.current_company_id;
    this.cable = Cable.createConsumer(url);

    if (this.cable) {
      this.subscribeToNotifications();
      this.subscribeToDataUpdates();
      this.subscribeToDataUpdatesAdmin();
      return this.cable;
    }
    else{
      return null;
    }
  }

  startCable(onTimer) {
    if (onTimer) {
      let inProgress = false;
      startTimer = setTimeout(() => {
        if (!inProgress) {
          inProgress = true;
          if (this.setupListener()) {
            clearInterval(startTimer);
          }
          inProgress = false;
        }
      }, 100);
      return;
    }

    this.token = localStorage.token;
    this.company_id = localStorage.current_company_id;

    if (!this.setupListener()) {
      this.startCable(true);
    }
  }

  stopCable() {
    if (this.cable) {
      if (this.notificationSubscription) {
        this.cable.subscriptions.remove(this.notificationSubscription);
        this.notificationSubscription = null;
      }
      if (this.dataUpdateSubscriptions) {
        this.cable.subscriptions.remove(this.dataUpdateSubscriptions);
        this.dataUpdateSubscriptions = null;
      }
      
      if (this.dataUpdateSubscriptionsAdmin) {
        this.cable.subscriptions.remove(this.dataUpdateSubscriptionsAdmin);
        this.dataUpdateSubscriptionsAdmin = null;
      }
      this.cable.disconnect();
    }
  }

  initialize() {
    if (localStorage.token && localStorage.current_company_id) {
      this.stopCable();
      this.startCable();
    }
  }

  uninitialize() {
    this.shuttingDown = true;
    this.stopCable();
  }

  /** NOTIFICATIONS */
  notificationReceived(data) {
    if (data && (data.user_id == parseInt(localStorage.loggedin_user_id, 10))) {
      dataModel.notificationsDataModel.newNotification = data;
      dataModel.mobileBridge.fireNativeEvent('hybrid.notifications', { data: { has_unread: true } });
    }
  }

  /** DATA UPDATES */

  /** DEPRECATED */
  register(key, callback) {
    this.registeredCallbacks[key] = callback;
  }

  /** DEPRECATED */
  unregister(key) {
    delete this.registeredCallbacks[key];
  }

  /** USAGE IN COMPONENT:  
   *    dataModel.actionCableConnector.registerCallback(this.handleProjectUpdatedOrDeleted, ['updateProject', 'deleteProject'])
   */

  registerCallback(callback, updateTypes, ids = [], recordDescriptor) {
    if (ids == null) {
      ids = [];
    }
    if (updateTypes && updateTypes.length && callback) {
      for (let updateType of updateTypes) {
        let idsForType = this._new_registeredCallbacks[updateType];
        if (!idsForType) {
          // create object for type and initialize generic (non-id) handler array
          idsForType = {
            generic: [],
          };
        }
        if (!ids.length) {
          // it's a generic handler
          idsForType.generic.push({ callback, recordDescriptor });
        }
        else for (let id of ids) {
          // associate handler with requested ids
          if (!idsForType[id]) {
            idsForType[id] = [];
          }

          // only add the callback once for the specific id
          if (!idsForType[id] || !idsForType[id].length || !idsForType[id].find(registeredCallback => registeredCallback.callback == callback)) {
            idsForType[id].push({ callback, recordDescriptor });
          }
        }
        this._new_registeredCallbacks[updateType] = idsForType;
      }
    }
  }

  /** USAGE IN COMPONENT:  
   *    dataModel.actionCableConnector.unregisterCallback(this.handleProjectUpdatedOrDeleted, ['updateProject', 'deleteProject'], [2,3])
   *   *** THE SAME FUNCTION REFERENCE PASSED TO REGISTER MUST BE USED HERE ***
   */
  unregisterCallback(callback, updateTypes, ids = []) {
    if (!ids) {
      ids = [];
    }
    if (updateTypes && updateTypes.length && callback) {
      for (let updateType of updateTypes) {
        const idsForType = this._new_registeredCallbacks[updateType];
        if (!idsForType) {
          continue;
        }
        else if (!ids.length) {
          const indexToDelete = idsForType.generic.findIndex(registeredCallback => registeredCallback.callback == callback);
          if (indexToDelete >= 0) idsForType.generic.splice(indexToDelete, 1);
        }
        else for (let id of ids) {
          if (idsForType[id]) {
            const indexToDelete = idsForType[id].findIndex(registeredCallback => registeredCallback.callback == callback);
            if (indexToDelete >= 0) idsForType[id].splice(indexToDelete, 1);
          }
        }
        this._new_registeredCallbacks[updateType] = idsForType;
      }
    }
  }

  findCallback(registeredCallbacksById, recordId) {
    if (recordId != null && recordId !== '') {
      if (registeredCallbacksById[recordId] && registeredCallbacksById[recordId].length) {
        return registeredCallbacksById[recordId];
      }
      const altId = typeof recordId === 'number' ? String(recordId) : parseInt(recordId, 10);
      if (!isNaN(altId) && registeredCallbacksById[altId] && registeredCallbacksById[altId].length) {
        return registeredCallbacksById[altId];
      }
    }
  }

  internalUpdate(acData, recordId) {
    acData._isInternal = true;
    this._updateObserversWithNewData(acData, recordId, null, null, null, null);
  }

  async _updateObserversWithNewData(acData, recordId, userId, taskIds, dataRequest) {
    const updateType = acData.type;
    if (this._new_registeredCallbacks[updateType]) {
      let registeredCallbacksById = this._new_registeredCallbacks[updateType];
      
      const callbacksToExecute = [];

      if (registeredCallbacksById) {
        if (registeredCallbacksById.generic && registeredCallbacksById.generic.length) {
          callbacksToExecute.push(...registeredCallbacksById.generic);
        }

        let callbackToRegister;
        if (recordId) {
          callbackToRegister = this.findCallback(registeredCallbacksById, recordId,);
          if (callbackToRegister) {
            callbacksToExecute.push(...callbackToRegister);
          }
        }
        if (userId && userId.length > 0) {
          callbackToRegister = this.findCallback(registeredCallbacksById, userId);
          if (callbackToRegister) {
            callbacksToExecute.push(...callbackToRegister);
          }
        }
        if (taskIds && taskIds.length > 0) {
          taskIds.forEach(async (id) => {
            const taskDataRequest = dataModel.tasksDAO.handleActionCableAndGetRequest({ type: acData.type, task_id: id });
            const taskFetchedData = await taskDataRequest();
            const taskCallbackToRegister = this.findCallback(registeredCallbacksById, id);
            if (taskCallbackToRegister) {
              taskCallbackToRegister.forEach(registeredCallback => {
                registeredCallback.callback(taskFetchedData, acData);
              });
            }
          });
        }
        if (callbacksToExecute.length) {
          if (dataRequest == 'delete') {
            for (let registeredCallback of callbacksToExecute) {
              registeredCallback.callback(null, acData);
            }
          }
          else {
            this.busy = true;
            let fetchedData = null;
            if (dataRequest) {
              // get any record descriptors and combine then
              let recordDescriptor = {};
              callbacksToExecute.forEach(registeredCallback => {
                if (registeredCallback.recordDescriptor) {
                  recordDescriptor = _.merge(recordDescriptor, registeredCallback.recordDescriptor);
                }
              });
              fetchedData = await dataRequest(recordId, { recordDescriptor, force: true });
            }
            try {
              callbacksToExecute.forEach(registeredCallback => {
                registeredCallback.callback(fetchedData, acData);
              });
            }
            catch (ex) {
              this.busy = false;
            }
            this.busy = false;
          }
        }
      }
    }
  }

  dataUpdateReceived(inData) {
    const self = this;
    if (!this.updateQueue) {
      this.updateQueue = [];
    }
    this.updateQueue.push(inData);
    if (this.queueTimer) {
      clearTimeout(this.queueTimer);
    }
    this.queueTimer = setTimeout(() => {
      self.doUpdateReceived();
    }, 10);
  }

  dataUpdateReceivedAdmin(inData) {
    const self = this;
    if (!this.updateQueue) {
      this.updateQueue = [];
    }
    this.updateQueue.push(inData);
    if (this.queueTimer) {
      clearTimeout(this.queueTimer);
    }
    this.queueTimer = setTimeout(() => {
      self.doUpdateReceived();
    }, 10);
  }

  /** DEPRECATED */
  callRegistered(data) {
    for (let key in this.registeredCallbacks) {
      if (key) {
        try {
          this.registeredCallbacks[key](data);
        }
        catch (e) {
          this.unregister(key);
        }
      }
    }
  }

  // TODO: REORDER UPDATE LOGIC
  doUpdateReceived() {
    if (this.busy) {
      const self = this;
      this.queueTimer = setTimeout(() => { self.doUpdateReceived(); });
    }
    else {
      while (this.updateQueue.length > 0) {
        let data = this.updateQueue.shift();
        let rdlDataRequest = null;
        let multiPartDataRequest = null;

        try {
          dataModel.actionCable = data;
        }
        catch (ex) {
          
        }
        let dataRequest = null;
        let recordId = null;
        let userId = null;
        let taskIds = [];

        switch (data.type) {
          // TODO: maybe make constants for these?

          /**
           * COMPANY
           */
        case 'newCompany':
          dataRequest = dataModel.companiesDAO.handleActionCableAndGetRequest(data);
          recordId = data.company_id;
          break;
        case 'updateCompany':
        case 'createMarket':
        case 'createCustomer':
        case 'deleteMarket':
        case 'updateMarket':
          dataRequest = dataModel.companiesDAO.handleActionCableAndGetRequest(data);
          recordId = data.company_id;
          break;
        case 'newVendorCompany':
          console.log('new vender');
          dataRequest = dataModel.companiesDAO.handleActionCableAndGetRequest(data);
          recordId = data.vendor_company_id;
          break;
        case 'deleteVendorCompany':
          console.log('delete vendor company');
          dataRequest = 'delete';
          recordId = data.vendor_company_id;
          break;
        case 'deleteCompany':
          dataRequest = 'delete';
          recordId = data.company_id;
          break;
          /**
           * LOCATION
           */
        case 'newLocation':
          dataRequest = dataModel.locationsDAO.handleActionCableAndGetRequest(data);
          recordId = data.location_id;
          break;
        case 'updateLocation':
          dataRequest = dataModel.locationsDAO.handleActionCableAndGetRequest(data);
          recordId = data.location_id;
          break;
        case 'deleteLocation':
          dataRequest = 'delete';
          recordId = data.location_id;
          break;
          /**
           * PROJECT TYPE
           */
        case 'newProjectType':
          dataRequest = dataModel.projectTypesDAO.handleActionCableAndGetRequest(data);
          recordId = data.project_type_id;
          break;
        case 'updateProjectType':
          dataRequest = dataModel.projectTypesDAO.handleActionCableAndGetRequest(data);
          recordId = data.project_type_id;
          break;
        case 'deleteProjectType':
          dataRequest = 'delete';
          recordId = data.project_type_id;
          break;
          /**
           * PROJECT TEMPLATE
           */
        case 'newProjectTemplate':
          dataRequest = dataModel.projectTemplatesDAO.handleActionCableAndGetRequest(data);
            // Project type because that is it's collection
          recordId = data.project_type_id;
          break;
        case 'updateProjectTemplate':
          dataRequest = dataModel.projectTemplatesDAO.handleActionCableAndGetRequest(data);
          recordId = data.project_template_id;
          break;
        case 'deleteProjectTemplate':
          dataRequest = 'delete';
          recordId = data.project_template_id;
          break;
  
          /**
           * PROJECT
           */
          // TODO: (as with most models) these next 3 cases can likely be combined 
        case 'newProject':
          dataRequest = dataModel.projectsDAO.handleActionCableAndGetRequest(data);
          recordId = data.project_id;
          break;
        case 'updateProjectMemberAssignments':
          dataRequest = dataModel.projectsDAO.handleActionCableAndGetRequest(data);
          recordId = data.project_id;
          if (data.user_ids) {
            userId = data.user_ids.find(id => { return id == dataModel.usersDAO.currentUser.id; });
          }
          break;
        case 'removeProjectMemberAssignments':
          dataRequest = 'delete';
          if (data.user_ids) {
            userId = data.user_ids.find(id => { return id == dataModel.usersDAO.currentUser.id; });
          }
          break;
        case 'updateProject':
            // There are lots of conditions that need this on an update: status changed, assignments changed, etc.
          dataRequest = dataModel.projectsDAO.handleActionCableAndGetRequest(data);
          recordId = data.project_id;
          break;
        case 'updateProjectForLocation':
          recordId = data.location_id;
          data.type = 'updateLocation';
          data.subStype = 'updateProjectForLocation';
          dataRequest = dataModel.locationsDAO.handleActionCableAndGetRequest(data, false);
          break;
        case 'updateBuildForLocation':
            // There are lots of conditions that need this on an update: status changed, assignments changed, etc.
          recordId = data.project_id;
          data.type = 'updateLocation';
          data.subStype = 'updateBuildForLocation';
          dataRequest = dataModel.locationsDAO.handleActionCableAndGetRequest(data, false);
          break;
        case 'deleteProject':
          dataRequest = 'delete';
          recordId = data.project_id;
          break;
        case 'deleteProjectForLocation':
          dataRequest = 'delete';
          recordId = data.location_id;
          data.type = 'updateLocation';
          data.subStype = 'deleteProjectForLocation';
          break;
          /**
       * BUILD
       */
        case 'newBuild':
          dataRequest = dataModel.buildsDAO.handleActionCableAndGetRequest(data);
          recordId = data.build_id;
          break;
        case 'updateBuild':
          dataRequest = dataModel.buildsDAO.handleActionCableAndGetRequest(data);
          recordId = data.build_id;
          break;
        case 'deleteBuild':
          recordId = data.build_id;
          dataRequest = 'delete';
          break;
          /**
       * TASK
       */
        case 'newTask':
          dataRequest = dataModel.tasksDAO.handleActionCableAndGetRequest(data);
          recordId = data.task_id;
          break;
        case 'updateTaskAssignments':
          dataRequest = dataModel.tasksDAO.handleActionCableAndGetRequest(data);
          if (data.user_ids) {
            userId = data.user_ids.find(id => { return id == dataModel.usersDAO.currentUser.id; });
          }
          else {
            userId = data.user_id;
          }
          if (data.sub_type == 'bulk_assign') {
            taskIds = data.task_ids;
          }
          else {
            recordId = data.task_id;
          }
            //Make sure the project gets added if not there
          if (!dataModel.projectsDAO.findItem(data.project_id)) {
            this.updateQueue.push({
              type: 'newProject', project_id: data.project_id, sub_type: 'updateTaskAssignments',
              company_id: dataModel.companiesDAO.currentCompany.id, updating_user_id: data.updating_user_id,
            });
          }
          break;
        case 'updateTask':
          dataRequest = dataModel.tasksDAO.handleActionCableAndGetRequest(data);
          recordId = data.task_id;
          break;
        case 'deleteTask':
          dataRequest = 'delete';
          recordId = data.task_id;
          break;
          /**
           * COMPLETION STEP
           */
        case 'newStep':
          dataRequest = dataModel.completionCriteriaDAO.handleActionCableAndGetRequest(data);
          recordId = data.task_id;
          break;
        case 'updateStep':
          dataRequest = dataModel.completionCriteriaDAO.handleActionCableAndGetRequest(data);
          recordId = data.step_id;
          break;
        case 'deleteStep':
          dataRequest = 'delete';
          recordId = data.step_id;
          break;

        case 'newAttachment':
          dataRequest = dataModel.attachmentsDAO.handleActionCableAndGetRequest(data);
          recordId = data.attachment_id;
          break;
        case 'updateAttachment':
          dataRequest = dataModel.attachmentsDAO.handleActionCableAndGetRequest(data);
          recordId = data.attachment_id;
          break;
        case 'deleteAttachment':
          dataRequest = 'delete';
          recordId = data.attachment_id;
          break;
  
        case 'newUniqueDocument':
          dataRequest = dataModel.uniqueDocumentsDAO.handleActionCableAndGetRequest(data);
          recordId = data.unique_document_id;
          break;
        case 'updateUniqueDocument':
          dataRequest = dataModel.uniqueDocumentsDAO.handleActionCableAndGetRequest(data);
          recordId = data.unique_document_id;
          break;
        case 'deleteUniqueDocument':
          dataRequest = 'delete';
          recordId = data.unique_document_id;
          break;
    
        case 'newReferenceDocument':
          dataRequest = dataModel.uniqueDocumentsDAO.handleActionCableAndGetRequest(data);
          recordId = data.reference_document_id;
          break;
        case 'updateReferenceDocument':
          dataRequest = dataModel.uniqueDocumentsDAO.handleActionCableAndGetRequest(data);
          recordId = data.reference_document_id;
          break;
        case 'deleteReferenceDocument':
          dataRequest = 'delete';
          recordId = data.reference_document_id;
          break;
          
        case 'newTeam':
        case 'updateTeam':
          dataRequest = dataModel.teamsDAO.handleActionCableAndGetRequest(data);
          recordId = data.team_id;
          break;
        case 'deleteTeam':
          recordId = data.team_id;
          dataRequest = 'delete';
          break;
          /**
     * USER
     */
        case 'newUser':
          dataRequest = dataModel.usersDAO.handleActionCableAndGetRequest(data);
          recordId = data.user_id;
          break;
        case 'updateUser':
        case 'newVendorUser':
          dataRequest = dataModel.usersDAO.handleActionCableAndGetRequest(data);
          recordId = data.user_id;
          break;
        case 'deleteUser':
        case 'deactivateUser':
        case 'deleteVendorUser':
        case 'archiveUser':
          if (+localStorage.loggedin_user_id == +data.user_id) {
            delete localStorage.token;
            dataModel.setNeedsLogin();
          }
          else {
            dataRequest = 'delete';
            recordId = data.location_id;
          }
          break;
          /**
           * REFERENCE DOCUMENT
           */
        case 'createRDL':
          if (data.sub_type == 'replaceRDL') {
            rdlDataRequest = data.task_ids.map(id_holder => {
              let rdlData = { id_type: 'task_id', task_id: id_holder.id, type: 'updateTask', sub_type: 'task_update', updating_user_id: data.updating_user_id };
              rdlData.dataRequest = dataModel.tasksDAO.handleActionCableAndGetRequest(rdlData);
              return rdlData;
            });
          }
          dataModel.referenceDocumentsDataModel.actionCableReferenceDocument = { createRDL: data };
          break;
          /**
           * CLOSEOUT
           */
        case 'createCloseout':
        case 'updateCloseout':
          recordId = data.closeout_id;
          dataRequest = dataModel.closeoutsDAO.handleActionCableAndGetRequest(data);
          break;
        case 'deleteCloseout':
          recordId = data.closeout_id;
          dataRequest = 'delete';
          break;
          /**
           * PROGRESS REPORT
           */
        case 'createProgressReport':
        case 'updateProgressReport':
          recordId = data.progress_report_id;
          dataRequest = dataModel.progressReportsDAO.handleActionCableAndGetRequest(data);
          break;
        case 'deleteProgressReport':
          recordId = data.progress_report_id;
          dataRequest = 'delete';
          break;
          /**
           * DELAY (mainly for attachments)
           */
        case 'updateDelay':
          recordId = data.delay_id;
          dataRequest = dataModel.delaysDAO.handleActionCableAndGetRequest(data);
          break;
          /**
           * ANNOUNCEMENT
           */
        case 'newAnnouncement':
        case 'updateAnnouncement':
          dataRequest = dataModel.announcementsDAO.handleActionCableAndGetRequest(data);
          recordId = data.announcement_id;
          break;
        case 'deleteAnnouncement':
          recordId = data.announcement_id;
          dataRequest = 'delete';
          break;

        default:
          break;
        }
        // mark collections NEEDS_SYNC as needed
        dataModel.collectionsDAO.handleCollectionActionCable(data);
        // fire callbacks after needs sync flags set - DEPRECATED
        if (rdlDataRequest) {
          rdlDataRequest.forEach(data => {
            this.callRegistered(data);
            if (data.dataRequest) {
              this._updateObserversWithNewData(data, data[data.id_type], userId, taskIds, data.dataRequest);
            }
          });
        }
        else if (multiPartDataRequest) {
          multiPartDataRequest.forEach(data => {
            this._updateObserversWithNewData(data, data.recordId, null, null, data.dataRequest);
          });
        }
        else {
          // Fetch/send new data to observing components.
          // newProjectTemplate may only have project_template_id (no project_type_id); we still run so generic callbacks get the event.
          if (dataRequest && (recordId || userId || taskIds.length > 0 || data.type === 'newProjectTemplate')) {
            this._updateObserversWithNewData(data, recordId, userId, taskIds, dataRequest);
          }
          this.callRegistered(data);
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/helpers/ActionCableConnector/ActionCableConnector.js